import { render, staticRenderFns } from "./DialogAudit.vue?vue&type=template&id=f6b2f35a&scoped=true&"
import script from "./DialogAudit.vue?vue&type=script&lang=js&"
export * from "./DialogAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b2f35a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6b2f35a')) {
      api.createRecord('f6b2f35a', component.options)
    } else {
      api.reload('f6b2f35a', component.options)
    }
    module.hot.accept("./DialogAudit.vue?vue&type=template&id=f6b2f35a&scoped=true&", function () {
      api.rerender('f6b2f35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Enroll/components/DialogAudit.vue"
export default component.exports